import axios from 'axios'
import CONFIG from '@/config'

import bus from '@/eventbus'
import { Auth } from '@aws-amplify/auth'
const BASE_URL = `${CONFIG.API_PATH}/content`

import store from '@/store/index'

async function setAuthHeader() {
	const session = await store.dispatch('getSession')

	const token = session.idToken.jwtToken
	axios.defaults.headers.common[ 'Authorization' ] = `Bearer ${token}`
}

const ContentService = {
	get: async (page) => {
		try {
			bus.$emit('loading-show')

			const URL = `${BASE_URL}/${page}`
			let result = await axios.get(URL)

			bus.$emit('loading-close')

			return result.data
		} catch (error) {
			bus.$emit('loading-close')
			throw new Error(error)
		}
	},
	save: async (data) => {
		try {
			// Make sure AWS Credentials are loadedawait setAuthHeader()
			await setAuthHeader()

			const { page } = data
			const URL = `${BASE_URL}/${page}`
			// const token = await setAuthHeader()

			return await axios.post(URL, data) // { headers: { Authorization: token }}
		} catch (error) {
			throw error
		}
	}
}

export default ContentService